import { Injectable } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";

import { GenericService } from "./generic.service";
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import jwtDecode from "jwt-decode";
import { UserProfileService } from "./user.service";

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  public currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;

  constructor(
    private genericService: GenericService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private userService: UserProfileService,
    private router: Router,
  ) {
    this.currentUserSubject = new BehaviorSubject<any>(
      JSON.parse(localStorage.getItem("currentUser"))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }
  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }
  public get baseUrl(): string {
    return environment.baseUrl;
  }

  public get isOfficeUser() {
    if (this.currentUserValue?.location?.toLowerCase() == 'office'.toLowerCase()) {
      return true;
    } else return false;
  }

  login(email: string, password: string) {
    this.spinner.show();
    return this.genericService.Post<any>(`auth/login`, { email, password })
      .pipe(map(user => {
        if (user.data && user.data.token) {
          localStorage.setItem('currentUser', JSON.stringify(user.data));
          this.currentUserSubject.next(user.data);
        }
        return user;
      }));
  }


  resetPassword(oldPassword: string, newPassword: string) {
    this.spinner.show();
    return this.genericService.Post<any>(`user/change-password`, { oldPassword, newPassword })
      .pipe(map(result => {
        this.spinner.hide();
        return result;
      }));
  }

  logout(id: any) {
    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
    localStorage.removeItem('sideMenu');
    var previousUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    this.router.navigate(['/account/login'], { queryParams: { returnUrl: previousUrl } });
    this.genericService.Get<any>(`auth/log-out-time/update/${id}`).subscribe(result => {
    });


  }

  forgetPassword(email: string) {
    this.spinner.show();
    return this.genericService.Get<any>(`auth/forget-password?email=${email}`).pipe(map(result => {
      return result;
    }));
  }

  getStages() {
    var user = JSON.parse(localStorage.getItem('currentUser'));
    if (user) {
      return user.stages;
    }
  }

  passwordReset(model: any) {
    return this.genericService.Post<any>(`auth/reset-password`, model);
  }

  decodeToken(token) {
    if (token) {
      var data = jwtDecode(token) as any;
      if (data) {
        data.token = token;
        localStorage.setItem('currentUser', JSON.stringify(data));
        this.currentUserSubject.next(data);
        this.router.navigate(['/']);
      }
    }
  }

  decodeThirdPartyToken(token) {
    if (token) {
      const data = jwtDecode(token) as any;
      if (data) {
        data.token = token;
        localStorage.setItem('currentUser', JSON.stringify(data));
        this.currentUserSubject.next(data);
        return data;
      }
    }
  }

  redirection(route: ActivatedRouteSnapshot) {
    const urltoken = route.queryParams['token'.toString()];
    if (urltoken) {
      const { id } = this.decodeThirdPartyToken(urltoken);

      this.userService.getUserById(id).subscribe((result) => {
        const response = result.data;
        localStorage.setItem('currentUser', JSON.stringify({ ...response, token: urltoken }));

        this.currentUserSubject.next({ ...response, token: urltoken });
        const moduleName = route.queryParams['moduleName'];
        this.router.navigate([moduleName]);

      });
      return true;

    }

    return false

  }


}
